export default {
    company_agency: "Store",
    document: "ID Number",
    extensions: "Format",
    project_name: "Elanco School",
    user: "E-mail",
    welcome_to: "Welcome to",
}